import React, { useState } from "react";
import { Trans } from "react-i18next";
import { useServisuBukle } from "../resources/useServisuBukle";
import "./ServisuBukleBanner.scss";

interface Props {}

function ServisuBukleBanner(props: Props) {
    const [dismissed, setDismissed] = useState(false);
    const downServices = useServisuBukle();
    const {} = props;

    const close = () => {
        setDismissed(true);
    };

    if (dismissed || downServices.length === 0) {
        return null;
    }

    return (
        <div className="servisu-bukle-banner" role="alert">
            <button onClick={close} className="close btn btn-icon" aria-label="close">
                <i className="la la-close"></i>
            </button>
            <div className="heading">
                <Trans i18nKey="servisuBukle.demesio" />
            </div>
            <ul className="message">
                {downServices.map((servisas) => (
                    <li key={servisas.kodas}>{servisas.vartotojoTekstas}</li>
                ))}
            </ul>
        </div>
    );
}

export default ServisuBukleBanner;
